import { Mail, Phone, Globe, User } from 'lucide-react';

interface ContactDetails {
  name?: string;
  email?: string;
  phone?: string;
  website?: string;
}

interface ContactInfoProps {
  contactDetails: ContactDetails;
  title?: string;
  className?: string;
}

export function ContactInfo({
  contactDetails,
  title = 'Contact Details',
  className = '',
}: ContactInfoProps) {
  const hasAnyContact =
    contactDetails.name || contactDetails.email || contactDetails.phone || contactDetails.website;

  if (!hasAnyContact) {
    return null;
  }

  return (
    <div className={className}>
      <h2 className="text-xl font-semibold mb-4">{title}</h2>
      <div className="grid grid-cols-1 gap-1">
        {contactDetails.name && (
          <div className="flex items-center gap-2 min-w-0">
            <User className="w-5 h-5 text-gray-500 flex-shrink-0" />
            <span className="text-gray-900 truncate">{contactDetails.name}</span>
          </div>
        )}
        {contactDetails.email && (
          <div className="flex items-center gap-2 min-w-0">
            <Mail className="w-5 h-5 text-gray-500 flex-shrink-0" />
            <a
              href={`mailto:${contactDetails.email}`}
              className="text-blue-600 hover:underline cursor-pointer truncate"
            >
              {contactDetails.email}
            </a>
          </div>
        )}
        {contactDetails.phone && (
          <div className="flex items-center gap-2 min-w-0">
            <Phone className="w-5 h-5 text-gray-500 flex-shrink-0" />
            <a
              href={`tel:${contactDetails.phone}`}
              className="text-blue-600 hover:underline cursor-pointer truncate"
            >
              {contactDetails.phone}
            </a>
          </div>
        )}
        {contactDetails.website && (
          <div className="flex items-center gap-2 min-w-0">
            <Globe className="w-5 h-5 text-gray-500 flex-shrink-0" />
            <a
              href={contactDetails.website}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 hover:underline cursor-pointer truncate"
            >
              {contactDetails.website}
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
